import { useEffect } from "react";
import confetti from "canvas-confetti";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "../ui/dialog";
import { ShareCard } from "./ShareCard";
import { ShareButtons } from "./ShareButtons";

const COLORS = ["#f59e0b", "#fbbf24", "#f472b6", "#a855f7", "#34d399", "#ffffff"];

export const fireConfetti = () => {
  const end = Date.now() + 1800;
  const opts = { colors: COLORS, zIndex: 9999, disableForReducedMotion: true };
  confetti({ ...opts, particleCount: 140, spread: 90, origin: { y: 0.6 } });
  (function frame() {
    confetti({ ...opts, particleCount: 4, angle: 60, spread: 60, origin: { x: 0 } });
    confetti({ ...opts, particleCount: 4, angle: 120, spread: 60, origin: { x: 1 } });
    if (Date.now() < end) requestAnimationFrame(frame);
  })();
};

export const CelebrationDialog = ({ c, onClose }) => {
  useEffect(() => { if (c) fireConfetti(); }, [c]);
  return (
    <Dialog open={!!c} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-xl" data-testid="celebration-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl" data-testid="celebration-heading">{c?.reason === "complete" ? "Every step done — congratulations!" : "You're published — congratulations!"}</DialogTitle>
          <DialogDescription>Share the moment. Anyone with the link can see this card.</DialogDescription>
        </DialogHeader>
        {c && <><ShareCard c={c} /><ShareButtons c={c} /></>}
      </DialogContent>
    </Dialog>
  );
};
